import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

export const initialState: any = {
  platformsUrls: null,
};
/* eslint-disable no-param-reassign */
const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setProjectPrivileges: (state, { payload: { projectPrivileges } }) => {
      state.projectPrivileges = projectPrivileges;
    },
    setPlatformsUrls: (state, { payload }) => {
      state.platformsUrls = payload;
    },
  },
});

export const { setProjectPrivileges, setPlatformsUrls } = globalSlice.actions;

export const selectGlobalDomain = (state: RootState): any => state.global;

export const selectPlatformsUrls = (state: RootState): Record<string, string> | null =>
  state.global.platformsUrls;

export default globalSlice.reducer;
